module.exports = __webpack_public_path__ + "media/images/hakone/hankyu_hakone_en02-75261b25f0c3adb0cea8a68f2ee6592e.jpg";